<div class="form-container" >
    <mat-card style="width: 100%;" appearance="outlined">
      <mat-card-content>
        <div class="form-row span-row" style="padding-bottom: 1rem;">
          <div class="form-col span-2">
            <div class="Label" style="color: rgba(0, 0, 0, 0.87); font-size: 16px; font-family: Roboto; font-weight: 400; line-height: 24px; letter-spacing: 0.15px; word-wrap: break-word">In case this property has more than 1 owner, add here</div>
          </div>
          <div class="form-col">   
               <button (click)="addNewPropertyOwner()" 
                       [disabled]="dataSource.data.length >= 3"
                       mat-stroked-button 
                       mat-button 
                       class="button-stepper-back">
            ADD
            <mat-icon>add</mat-icon>
          </button>
          <div *ngIf="dataSource.data.length >= 3" style="
              color: #f44336;
              font-size: 12px;
              margin-top: 4px;
              font-family: Roboto;
            ">
            Maximum of 3 additional owners allowed
          </div>
        </div>
        </div>
        <div class="form-row">
          <div class="form-col">
            <table mat-table [dataSource]="dataSource" >
  
              <!-- ID Column -->
              <ng-container matColumnDef="firstName">
                <th style="background-color: #E3E3E3;color:#000000" mat-header-cell *matHeaderCellDef>First name</th>
                <td mat-cell *matCellDef="let element"> {{element.firstName}} </td>
              </ng-container>
            
              <!-- Name Column -->
              <ng-container matColumnDef="lastName">
                <th  style="background-color: #E3E3E3;" mat-header-cell *matHeaderCellDef>Last name</th>
                <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
              </ng-container>
            
              <!-- Email Column -->
              <ng-container matColumnDef="email">
                <th  style="background-color: #E3E3E3;" mat-header-cell *matHeaderCellDef>Email address</th>
                <td mat-cell *matCellDef="let element"> {{element.email}} </td>
              </ng-container>
      
                  <!-- Email Column -->
                  <ng-container matColumnDef="phone">
                    <th  style="background-color: #E3E3E3;" mat-header-cell *matHeaderCellDef>Phone number</th>
                    <td mat-cell *matCellDef="let element"> {{element.phoneNumber}} </td>
                  </ng-container>
                  <!-- Email Column -->
                  <ng-container matColumnDef="action">
                    <th style="background-color: #E3E3E3;" mat-header-cell *matHeaderCellDef>Actions</th>
                    <td mat-cell *matCellDef="let element;let i=index;">   <mat-icon style="color: #2196F3;" class="icon-pointer" (click)="editOwner(element)" aria-label="Edit">edit</mat-icon>    <mat-icon (click)="removeOwner(i)" class="icon-pointer" style="color: red;" aria-label="Delete">delete</mat-icon>  </td>
                  </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            
            </table>
         
          </div>
      </div>
      </mat-card-content>
    </mat-card>
   

</div>